import { createAnnotelyEditorApp } from './editor';
createAnnotelyEditorApp(document.querySelector('div.annotely-editor-container'));
